import { combineReducers } from "redux";

import { InSureReducer } from "./InSureReducer";
import { QuotationReducer } from "./QuotationReducer";
import { searchReducer } from "./searchReducer";
import { userReducer } from "./userReducer";

const rootReducer = combineReducers({
  user: userReducer,
  search: searchReducer,
  product : InSureReducer,
  quotation : QuotationReducer,
});

export default rootReducer
